export default {
  PRODUCT: "प्रोडक्ट",
  PRODUCTS: "प्रोडक्ट्स",
};
